<template>
  <div class="nav">
    <ul class="navbar" v-if="showNab === '0'">
      <li v-for="(item, index) in navbarList" :key="item.name" :class="[isRouterLink === index ? 'active' : '']" @click="toggle(index, item.path)">
        {{ item.name }}
      </li>
    </ul>
    <!--    多项滚动导航-->
    <ul class="navbar1" v-if="showNab === '2'">
      <li v-for="(item, index) in navbarList" :key="item.memoCatId" :class="[navActive1 === index ? 'active1' : '']" @click="toggle1(index, item.memoCatId)">
        {{ item.typeName }}
      </li>
    </ul>
    <ul class="navbar1" v-if="showNab === '1'">
      <li v-for="(item, index) in navbarList" :key="item.typeId" :class="[isRouterLink === index ? 'active' : '']" @click="toggle(index, item.typeId, item.path)">
        {{ item.typeName }}
      </li>
    </ul>
    <ul class="navbar1" v-if="showNab === ''">
      <li v-for="(item, index) in navbarList" :key="item.typeId" :class="[isRouterLink === index ? 'active' : '']" @click="toggle(index, item.typeId, item.path)">
        {{ item.typeName }}
      </li>
    </ul>
    <ul class="navbar1" v-if="showNab === 'productType'">
      <li v-for="(item, index) in navbarList" :key="item.typeId" :class="[isRouterLink === index ? 'active' : '']" @click="toggle(index, item.typeId)">
        {{ item.typeName }}
      </li>
    </ul>
    <ul class="navbar1" v-if="showNab === '3'">
      <li v-for="(item, index) in navbarList" :key="item.shelfId" :class="[isRouterLink === index ? 'active' : '']" @click="toggle(index, 'shelf', item.shelfId)">
        {{ item.shelfName }}
      </li>
    </ul>

    <ul class="navbar1" v-if="showNab === 'resourceType'">
      <li v-for="(item, index) in navbarList" :key="item.resourceTypeId" :class="[isRouterLink === index ? 'active' : '']" @click="toggle(index, 'resourceType', item.resourceTypeId)">
        {{ item.resourceTypeName }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Tab',
  data() {
    return {
      // navbarList:['默认','价格','销量'],
      navActive: 0,
      navActive1: 0
    }
  },
  props: {
    //是否是固定的三个导航
    showNab: {
      type: String,
      default: '0'
    },
    //标识：
    test: {
      type: String,
      default: null
    },
    //跳转列表
    navbarList: {
      type: Array,
      default() {
        return [{ name: '默认' }, { name: '价格' }, { name: '销量' }]
      }
    },
    //是做路由跳转还是做单页面显示隐藏
    isRouter: {
      type: String,
      default: 'routerLink'
    },
    activeIndex: { // 新增的 prop
      type: Number,
      default: 0
    }
  },
  computed: {
    navActiveIndex({ $store }) {
      console.log('xxx', { $store })

      if ($store.state.bmTab === 3) {
        return $store.getters.getTalkbaoIndex
      }
      if ($store.state.bmTab === 4) {
        return $store.getters.getImprintIndex
      }
    },
    //是路由跳转就返回根据路由去匹配的全局变量,如果只是页面跳转那么就返回局部的
    isRouterLink({ $props, $data }) {
      console.log('sss', $props.isRouter)
      console.log('不是', $data)

      if (this.showNab === '3') {
        return this.activeIndex; // 使用父组件传递的 activeIndex
      }

      if (this.showNab === 'resourceType') {
        return this.activeIndex; // 使用父组件传递的 activeIndex
      }

      if ($props.isRouter === 'routerLink') {
        return this.navActiveIndex
      } else {
        return $data.navActive
      }
    }
  },
  methods: {
    ...mapActions(['setTalkbaoIndex']),
    // 切换tab选项页
    toggle(i, p, item) {
      console.log(i, p, item)
      if (this.isRouter === 'unRouterLink') {
        this.navActive = i

        if (this.showNab === 'page') {
          this.$emit('changePage', { page: i })
          return
        }

        if (this.showNab === '0') {
          this.$emit('changePage', { status: i, index: i })
          return
        }
        if (this.showNab === '3') {
          this.$emit('update:activeIndex', i); // 触发父组件更新 activeIndex
          this.$emit('changePage', { index: i, shelfId: item})
          return
        }
        if (this.showNab === 'resourceType') {
          this.$emit('update:activeIndex', i); // 触发父组件更新 activeIndex
          this.$emit('changePage', { index: i, resourceTypeId: item})
          return;
        }

        if (this.showNab === 'productType') {
          this.$emit('update:activeIndex', i); // 触发父组件更新 activeIndex
          this.$emit('changePage', { index: i, typeId: p})
          return
        }

        this.$emit('changePage', { platform: p })
      } else {
        console.log('jinalailenali1')

        p ? this.$router.push({ path: p }) : this.$router.push({ path: item })
      }
    },
    toggle1(i, id) {
      console.log('topbar的memoCatId', id)
      console.log(i)
      this.navActive1 = i
      this.$emit('changeBroadSide', i, id)
    }

  }
}
</script>

<style scoped lang="scss">
@import '../../assets/mixin.scss';
.nav {
  .van-swipe-item {
    font-size: 12px;
  }
  width: 100%;
  height: 86px;
  .navbar,
  .navbar1 {
    width: 100%;
    height: 100%;
    @include flex($around);
    li {
      //width: calc(100% / 3);
      height: 100%;
      text-align: center;
      line-height: 86px;
      font-size: 28px;
      font-weight: bold;
      color: #999999;
    }
    .active {
      color: #50cc73;
      position: relative;
      &:after {
        content: ' ';
        display: block;
        width: 100%;
        height: 4px;
        background: linear-gradient(271deg, #2fb555 0%, #50cc73 100%);
        border-radius: 4px 4px 4px 4px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .active1 {
      color: #50cc73;
      position: relative;
      &:after {
        content: ' ';
        display: block;
        width: 24px;
        height: 4px;
        background: linear-gradient(271deg, #2fb555 0%, #50cc73 100%);
        border-radius: 4px 4px 0px 0px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }



  //.navbar1 {
  //  @include flex($start);
  //  border-color: #00997a;
  //  li {
  //    padding: 0 17px 0 17px;
  //    /*padding-right: 68px;*/
  //    white-space: nowrap;
  //    &:last-child {
  //      padding-right: 32px;
  //    }
  //    &:last-child {
  //      &.active {
  //        &:after {
  //          transform: translateX(-125%);
  //        }
  //      }
  //    }
  //  }
  //}

}
</style>



// WEBPACK FOOTER //
// src/components/Tab/Tab.vue